import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import Media from 'react-media';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import images from 'core/images/frontpage';

class SlideShow extends React.Component {
    static propTypes = {};

    render() {
        return (
            <Media query="(max-width: 750px)">
                {matches => (
                    <div css={{ backgroundColor: 'black', height: matches ? 250 : 500 }}>
                        <Link to="/galleries">
                            <Slider
                                dots={false}
                                infinite={true}
                                speed={3000}
                                slidesToShow={1}
                                autoplay={true}
                                centerMode={true}
                                fade={true}
                                lazyLoad={true}
                                arrows={false}
                                pauseOnHover={false}
                            >
                                {images.map((img, i) => (
                                    <div key={i}>
                                        <img
                                            src={img.src}
                                            alt="Selected photograph by Alan Honey"
                                            css={{ margin: 'auto', height: matches ? 250 : 500 }}
                                        />
                                    </div>
                                ))}
                            </Slider>
                        </Link>
                    </div>
                )}
            </Media>
        );
    }
}

export default SlideShow;



// WEBPACK FOOTER //
// ./src/pages/Home/components/SlideShow/index.js